import { GET_ORDER_QUERY, GET_BUSINESS_ORDER_QUERY } from '../../graphql/order'
import { apolloClient } from '../../graphql/apollo'
import { store } from '../../store'
import axios from 'axios';


const allOrders = localStorage.getItem('orders') ? JSON.parse(localStorage.getItem('orders')) :  false;
const initialState = allOrders
    ? { orders: allOrders }
    : { orders:[] };

export const orders = {
    namespaced: true,
    state: initialState,
    getters: {
          getOrders: (state) => {
                const allOrders = state.orders
                allOrders.sort((a, b) => b.createdAt - a.createdAt)

                return allOrders
          },
          getOrder: (state) => (orderNo) => {
            const allorders = state.orders
            const found = allorders.find((order) => order.orderNo == orderNo)

            return found
          },
          pending: (state) => {
            //
            const data = state.orders
            const pendingContent = data.filter((order)=>  order.confirmed == null && order.cancelled == null)
            // sort in desc
            pendingContent.sort((a, b) => b.createdAt - a.createdAt)

            return pendingContent
          },
          confirmed: (state) => {
            //
            const data = state.orders
            const confirmedContent = data.filter((order)=> order.confirmed !== null && order.orderDelivered == null)
            // sort in desc
            confirmedContent.sort((a, b) => b.createdAt - a.createdAt)

            return confirmedContent
          },
          completed: (state) => {
            //
            const data = state.orders
            const completedContent = data.filter((order)=> order.orderDelivered !== null)
            // sort in desc
            completedContent.sort((a, b) => b.createdAt - a.createdAt)
        
            return completedContent
          },
          cancelled: (state) => {
            //
            const data = state.orders
            const cancelledContent = data.filter((order)=> order.cancelled !== null)
            // sort in desc
            cancelledContent.sort((a, b) => b.createdAt - a.createdAt)
        
            return cancelledContent
          },

    },
    actions: {
        async Order({ state,commit }, data ) {
            //
            commit('place', data)

        },
        async getOrders({ state,commit } ) {
            //
            let resp
            let data

            const user = store.getters['auth/getUser'];
            // console.log(user)
            //
            if (user) {
                // resp = await apolloClient.query({ query: GET_ORDER_QUERY, variables: { vendor: user.business } })
                // data = resp.data.allOrders.filter((order) => order.payment !== null || order.payment.status == "success")

                axios.get('/order/'+user.name).then((res)=>{
                  //
                  if (res.data) {
                    //
                    data = res.data
                    //
                    for (let index = 0; index < data.length; index++) {
                        // const element = array[index];
                        
                        data[index].payAmount = ((100 - user.commission)/100) * data[index].totalPrice
                        // data.push(data[index])
                        
                    }
                    //
                    commit('updateOrders', data)
                }
                  // data = res.data.filter((order) => order.payment !== null || order.payment.status == "success")
                  
                })

                if (data) {
                    commit('updateOrders', data)
                }
                
            }
            
        }
    },
    mutations: {
        place: (state, data) => {
            state.newOrder = data
        },
        updateOrders: (state, data) => {
            state.orders = data
        },
    }
}